var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hkl-input-points" },
    [
      _vm.isEdit
        ? _c(
            "HKLInputNumber",
            _vm._g(
              _vm._b(
                {
                  directives: [
                    {
                      name: "fusioninputcheck",
                      rawName: "v-fusioninputcheck",
                      value: {
                        type: "string",
                        pattern: _vm.pointFusionInputCheckPattern,
                        required: _vm.proxyValue,
                        showTip: false,
                      },
                      expression:
                        "{\n      type: 'string',\n      pattern: pointFusionInputCheckPattern,\n      required: proxyValue,\n      showTip: false,\n    }",
                    },
                  ],
                  model: {
                    value: _vm.proxyValue,
                    callback: function ($$v) {
                      _vm.proxyValue = $$v
                    },
                    expression: "proxyValue",
                  },
                },
                "HKLInputNumber",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            )
          )
        : _c("HKLText", {
            attrs: { text: _vm.proxyValue || _vm.$t("emptyValue") },
          }),
      _vm._v(" "),
      _c("HKLText", {
        attrs: { text: _vm.$t("tenancy.greenOperation.assessments.points") },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }